export const disableProductionConsole = () => {
  if (process.env.NODE_ENV !== "production" || typeof console === "undefined") {
    return;
  }

  const noop = () => {};
  ["log", "info", "debug", "warn", "error"].forEach((method) => {
    console[method] = noop;
  });
};

